import { render, staticRenderFns } from "./Instance.vue?vue&type=template&id=2d8e834c"
import script from "./Instance.vue?vue&type=script&lang=js"
export * from "./Instance.vue?vue&type=script&lang=js"
import style0 from "./Instance.vue?vue&type=style&index=0&id=2d8e834c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports